import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface PrivacyPolicyModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function PrivacyPolicyModal({
  isOpen,
  onClose
}: PrivacyPolicyModalProps) {
  return <AnimatePresence data-id="element-168">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-169">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" data-id="element-170" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3,
        ease: 'easeOut'
      }} onClick={e => e.stopPropagation()} className="relative bg-[#FAF7F2] text-[#2D1B4E] rounded-2xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-hidden" data-id="element-171">
            {/* Header */}
            <div className="sticky top-0 bg-[#FAF7F2] border-b border-[#E8D5D5] px-6 py-4 flex items-center justify-between z-10" data-id="element-172">
              <h2 className="text-xl font-bold font-serif" data-id="element-173">Privacy Policy</h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-[#E8D5D5] transition-colors" aria-label="Close privacy policy" data-id="element-174">
                <X className="w-5 h-5" data-id="element-175" />
              </button>
            </div>

            {/* Content */}
            <div className="px-6 py-6 overflow-y-auto max-h-[calc(85vh-64px)] text-sm leading-relaxed space-y-6" data-id="element-176">
              <p className="text-gray-500 text-xs" data-id="element-177">
                Last updated: February 2026
              </p>

              <section data-id="element-178">
                <h3 className="font-bold text-base mb-2" data-id="element-179">
                  1. Information We Collect
                </h3>
                <p className="text-gray-700" data-id="element-180">
                  When you purchase{' '}
                  <em data-id="element-181">From Trauma to Self-Love: Shadow Work Secrets</em>, we
                  collect only the information necessary to process your order,
                  including your name, email address, and payment details.
                  Payment processing is handled securely by our third-party
                  payment provider.
                </p>
              </section>

              <section data-id="element-182">
                <h3 className="font-bold text-base mb-2" data-id="element-183">
                  2. How We Use Your Information
                </h3>
                <p className="text-gray-700" data-id="element-184">
                  We use your information to deliver your digital purchase, send
                  order confirmations, and provide customer support. We may also
                  send occasional updates about related resources—you can
                  unsubscribe at any time.
                </p>
              </section>

              <section data-id="element-185">
                <h3 className="font-bold text-base mb-2" data-id="element-186">3. Data Protection</h3>
                <p className="text-gray-700" data-id="element-187">
                  We take your privacy seriously. Your personal data is
                  encrypted and stored securely. We never sell, trade, or share
                  your personal information with third parties for marketing
                  purposes.
                </p>
              </section>

              <section data-id="element-188">
                <h3 className="font-bold text-base mb-2" data-id="element-189">4. Cookies</h3>
                <p className="text-gray-700" data-id="element-190">
                  This website uses minimal cookies to ensure functionality and
                  improve your browsing experience. No tracking cookies are used
                  for advertising purposes.
                </p>
              </section>

              <section data-id="element-191">
                <h3 className="font-bold text-base mb-2" data-id="element-192">5. Your Rights</h3>
                <p className="text-gray-700" data-id="element-193">
                  You have the right to access, correct, or delete your personal
                  data at any time. To make a request, please contact our
                  support team using the link in the footer.
                </p>
              </section>

              <section data-id="element-194">
                <h3 className="font-bold text-base mb-2" data-id="element-195">6. Refund Policy</h3>
                <p className="text-gray-700 mb-3" data-id="element-196">
                  We want you to be completely satisfied. If you encounter an
                  issue, you must notify us within the first 7 days of purchase.
                  Once notified, and if eligible, refunds can be processed up to
                  30 days from the purchase date.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-197">
                  Refunds apply in the following cases:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-1 ml-2 mb-3" data-id="element-198">
                  <li data-id="element-199">
                    Technical issues preventing ebook access that cannot be
                    resolved.
                  </li>
                  <li data-id="element-200">Accidental duplicate purchases.</li>
                </ul>
                <p className="text-gray-700" data-id="element-201">
                  Contact us via WhatsApp Business at{' '}
                  <a href="https://wa.me/15512540741" target="_blank" rel="noopener noreferrer" className="text-[#25D366] hover:underline font-medium" data-id="element-202">
                    +1 551-254-0741
                  </a>{' '}
                  or email us at{' '}
                  <a href="mailto:info@dreambuk.com" className="text-[#D4A574] hover:underline font-medium" data-id="element-203">
                    info@dreambuk.com
                  </a>{' '}
                  to initiate a refund request.
                </p>
              </section>

              <section data-id="element-204">
                <h3 className="font-bold text-base mb-2" data-id="element-205">7. Contact</h3>
                <p className="text-gray-700" data-id="element-206">
                  If you have any questions about this Privacy Policy, please
                  reach out to us through our Contact Support link.
                </p>
              </section>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}